import { Button } from "carbon-components-react";
import React from "react";
import { useNavigate } from "react-router-dom";
import NewTeamNotification from "../newTeam/NewTeamNotification";
import DonationNotification from "../donate/DonationNotification";
import { ImageCluster, PinnacleFoundationLogo } from "../../components";
import ChicagoRegattaCup from "../../images/chicago_regatta_cup.png";

const Home = () => {
  const navigate = useNavigate();

  return (
    <React.Fragment>
      <NewTeamNotification />
      <DonationNotification />
      <div className="container">
        <ImageCluster />
        <div className="content-container">
          <div className="content-cluster-top" />
          <div className="content-cluster-bottom">
            <div className="content-cluster-buttons">
              <Button onClick={() => navigate("/view_leaderboard")}>
                VIEW LEADERBOARD
              </Button>
              <Button onClick={() => navigate("/donation")}>
                DONATE TO A TEAM
              </Button>
              <Button onClick={() => navigate("/create_new_team")}>
                CREATE A TEAM
              </Button>
            </div>
            <div className="content-cluster-images">
              <img alt="Chicago Regatta Cup" src={ChicagoRegattaCup} />
              <PinnacleFoundationLogo />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Home;
